import { MemberProfileDimensionModel } from 'src/app/api/proxy/datapoints/models/member-profile-dimension-model';

/** Fingerprint of dimension questions/setup (excludes user answers). */
export function getDimensionSetupFingerprint(dimensions: MemberProfileDimensionModel[] | null | undefined): string {
  if (!dimensions?.length) {
    return '[]';
  }

  const items = dimensions.map((dim) => ({
    key: dim.key ?? '',
    name: dim.name ?? '',
    description: dim.description ?? '',
    valueType: dim.valueType ?? '',
    orderNumber: dim.orderNumber ?? null,
    allowedValues: [...(dim.allowedValues ?? [])].sort(),
  })).sort((a, b) => a.key.localeCompare(b.key));

  return JSON.stringify(items);
}

/** True when the server question setup differs from a previously cached setup. */
export function hasDimensionSetupChanged(
  previous: MemberProfileDimensionModel[] | null | undefined,
  next: MemberProfileDimensionModel[] | null | undefined,
): boolean {
  if (!previous?.length || !next?.length) {
    return false;
  }

  return getDimensionSetupFingerprint(previous) !== getDimensionSetupFingerprint(next);
}
